/*
    This file is part of webu.js.

    webu.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    webu.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with webu.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file db.js
 * @authors:
 *   Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var Method = require('../method');

var DB = function(webu) {
    this._requestManager = webu._requestManager;

    var self = this;

    methods().forEach(function(method) {
        method.attachToObject(self);
        method.setRequestManager(webu._requestManager);
    });
};

var methods = function() {
    var putString = new Method({
        name: 'putString',
        call: 'db_putString',
        params: 3,
    });

    var getString = new Method({
        name: 'getString',
        call: 'db_getString',
        params: 2,
    });

    var putHex = new Method({
        name: 'putHex',
        call: 'db_putHex',
        params: 3,
    });

    var getHex = new Method({
        name: 'getHex',
        call: 'db_getHex',
        params: 2,
    });

    return [
        putString, getString, putHex, getHex,
    ];
};

module.exports = DB;
